'use client';
import React, { useEffect } from 'react';

function processImages(text) {
  return text.replace(
    /!\[(.*?)\]\((.*?)\)/g,
    (match, alt, src) => {
      const altText = alt.replace(/\.[^/.]+$/, '');
      return `<img src="${process.env.NEXT_PUBLIC_BE_URL}${src}" alt="${altText}" class="block w-full h-auto max-w-3xl max-h-[440px] object-cover border-solid border rounded-3xl mb-4 mx-auto" />`;
    }
  );
}

function processVideos(text) {
    return text.replace(
      /\[(.*?)\]\((.*?)\)/g,
      (match, text, url) => {
        if (url.endsWith('.mp4')) {
          return `<div class="blog-video-holder"><video class="blog-item-video" src="${process.env.NEXT_PUBLIC_BE_URL}${url}" width="854" height="480" controls muted preload="none"></video></div>`;
        } else if (url.includes('youtube.com') || url.includes('youtu.be')) {
          const videoId = url.match(
            /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
          )[1];
          return `<div class="blog-video-holder"><a href="https://www.youtube.com/watch?v=${videoId}" target="_blank"><img src="https://img.youtube.com/vi/${videoId}/0.jpg" alt="${text}" width="854" height="480" class="thumbnail-image w-fit h-auto flex justify-start" /></a></div>`;
        } else {
          return `<a class="text-primaryBlue duration-500 transition-all ease-in-out" href="${url}">${text}</a>`;
        }
      }
    );
  }
  

function handleIntersection(entries) {
  entries.forEach((entry) => {
    const video = entry.target.querySelector('video');
    const iframe = entry.target.querySelector('iframe');

    if (entry.isIntersecting) {
      if (video && !video.playedOnce) {
        video.play().then(() => {
          video.playedOnce = true;
        });
      }
      if (iframe) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          '*'
        );
      }
    } else {
      if (video && video.playedOnce && !video.paused) {
        video.pause();
      }
      if (iframe) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      }
    }
  });
}

function setupIntersectionObserver(videoElements) {
  const observer = new IntersectionObserver(
    handleIntersection,
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    }
  );

  videoElements.forEach((element) => {
    const isVideo = element.tagName.toLowerCase() === 'video';
    if (isVideo) {
      element.pause();
    }
    observer.observe(isVideo ? element.parentElement : element);
  });

  // Cleanup function
  return () => {
    observer.disconnect();
  };
}

function BlogInternDetails(props) {
  const blogdetdata = props.data.data[0]?.attributes.blogDescription || null;
  let formattedText = processImages(blogdetdata);
  formattedText = processVideos(formattedText);
  const blogSections = formattedText?.split(/\n{2,}/);

  useEffect(() => {
    const videoElements = document.querySelectorAll('.blog-video-holder video, .blog-video-holder iframe');
    const cleanupObserver = setupIntersectionObserver(videoElements);
    return cleanupObserver;
  }, [blogSections]);

  return (
    <div className="mt-6 text-justify md:p-4 custom-container details_section">
      {blogSections?.map((section, i) => {
        const lines = section.split('\n');
        let sectionContent;

        if (lines[0].startsWith('<img')) {
          sectionContent = (
            <div
              dangerouslySetInnerHTML={{ __html: section }}
              key={i}
              className="blog-images"
            />
          );
        } else if (
          lines[0].startsWith('<div class="blog-video-holder"')
        ) {
          sectionContent = (
            <div
              dangerouslySetInnerHTML={{ __html: section }}
              key={i}
              className="blog-videos w-full max-w-5xl max-h-[500px] h-auto mx-auto my-8 text-center"
            />
          );
        } else if (lines[0].match(/^#{3,}\s/)) {
          sectionContent = (
            <h3 className="text-primaryBlue header-sub capitalize font-bold leading-snug tracking-normal mt-5">
              {lines[0].replace(/^#{3,}\s/, '')}
            </h3>
          );
        } else {
          const listItems = lines.map((line, lineIndex) => {
            const boldText = line.replace(
              /\*\*(.*?)\*\*/g,
              '<strong>$1</strong>'
            );
            const italicText = boldText.replace(/_([^_]+)_/g, '<em>$1</em>');
            const listItem = line.startsWith('- ') ? (
              <li
                className="list-disc text-primaryGreyText leading-snug text-lg sm:text-base tracking-normal mt-1 mb-3"
                key={lineIndex}
                dangerouslySetInnerHTML={{ __html: italicText.substring(2) }}
              />
            ) : (
              <p
                className="text-primaryGreyText leading-snug text-lg sm:text-base tracking-normal mt-1 mb-3"
                key={lineIndex}
                dangerouslySetInnerHTML={{ __html: italicText }}
              />
            );
            return listItem;
          });

          sectionContent = <ul className="mb-3">{listItems}</ul>;
        }

        return <div key={i} className="subheader">{sectionContent}</div>;
      })}
    </div>
  );
}

export default BlogInternDetails;